import { Link } from "react-router-dom";

import styled from "styled-components";

import { theme } from "../../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;

  font-family: ${theme.font.poppins};
  color: ${theme.colors.white};

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.darkBlue};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800};
  }

  @media screen and (max-width: 768px) {
    width: 100%;

    .data-grid {
      display: none !important;
    }
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;

  @media screen and (min-width: 768px) {
    display: none;
  }
`;

type StatusProp = {
  color: string;
};

export const TitleContainer = styled.div`
  display: flex;
  /* margin-top:30px; */
  margin-bottom: 15px;
`;

export const CardWrapper = styled.div`
  margin-top: 10px;
  margin: 15px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 15px;
  justify-content: space-between;
  background-color: ${theme.colors.darkBlue};

  @media screen and (max-width: 360px) {
    margin: 0;
  }

  @media screen and (max-width: 479px) {
    div.d-flex {
      flex-wrap: wrap;
      gap: 0.5rem;
    }
  }
`;

export const ExportButtonComponentStyled = styled.button`
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  align-items: center;
  padding: 13px 70px;
  border: 1px solid ${theme.colors.darkGray};
  border-radius: 100px;
  font-size: 0.8rem;
  margin-left: 15px;
  line-height: 1.6;
  &:hover {
    opacity: 0.7;
  }
  svg {
    margin-bottom: 2px;
    margin-right: 10px;
  }
  @media screen and (max-width: 479px) {
    border: 1px solid black !important;
  }
`;

type ProgressProps = {
  value?: number | 0;
  max?: number | 100;
};

export const ProgressStyled = styled.progress`
  height: 12px;
  border: 1px solid ${theme.colors.primary};
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }

  &::before {
    width: 100%;
    background: #fff;
  }

  &::after {
    width: ${(e: ProgressProps) =>
      e?.value ? (e?.value * 100) / (e?.max || 0) : 0}%;
    border-radius: 15px;
    background: ${theme.colors.primary};
  }
`;

export const FilterStyled = styled.div`
  position: relative;
  width: 100%;
  min-width: 250px;
  padding: 0px 15px 15px 15px;
  display: flex;
  flex-direction: column;
`;
export const FieldCheckbox = styled.label`
  font-weight: 400;
  color: ${theme.colors.black};
  font-size: 0.8rem;
  font-family: "poppins";
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`;

export const CheckboxStyled = styled.input`
  font-weight: 400;
  color: ${theme.colors.black};
  font-size: 1.5rem;
  font-family: "poppins";
  margin-right: 8px;
  accent-color: #01ac1c;
`;

export const ButtonStyled = styled.button`
  margin: 5px 0;
  height: 1px;
  width: 100%;
  background-color: ${theme.colors.lightGray};
  padding: 20px;
  width: 100%;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  margin-top: 30px;
`;

export const SperatorStyled = styled.span`
  margin: 5px 0;
  height: 1px;
  width: 100%;
  padding: 0 5px;
  background-color: ${theme.colors.lightGray};
`;

export const TitleStyledFilter = styled.h5`
  display: flex;
  font-weight: 400;
  color: ${theme.colors.black};
  font-size: 0.8rem;
  font-family: "poppins";
  margin-bottom: 10px;
  margin-top: 10px;
`;

export const DateContainer = styled.div`
  display: flex;
`;

export const DateStyled = styled.input`
  margin-right: 10px;
  border: 1px solid ${theme.colors.primary};
  color: ${theme.colors.black};
  max-width: 100px;
  border-radius: 6px;
  padding: 10px 5px;
  font-size: 0.8rem;
  font-family: "poppins";
`;

export const LabelStyled = styled.label`
  display: flex;
  flex-direction: column;
  font-size: 0.8rem;
  font-family: "poppins";
  font-weight: 400;
  color: ${theme.colors.primary};
`;

export const TitleStyled = styled.h1`
  color: ${theme.colors.black};
  font-size: 2rem;
  padding: 0 15px;
  font-weight: 500;
`;

export const StatusStyled = styled.li`
  color: ${(p: StatusProp) => p.color};
`;

export const RatingStyled = styled.div`
  width: 100%;
  display: flex;
  p {
    margin-left: 5px;
    margin-bottom: 0;
  }
  align-items: center;
`;

export const RowStyled = styled.div`
  width: 100%;
  display: flex;
`;

export const RowTitleStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-right: 15px;
  margin-bottom: 15px;
`;

export const SplitStyled = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  height: calc(50% - 10px);
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 70%;
`;

type ColProp = {
  width: number;
};

export const ColStyled = styled.div`
  margin: 10px;
  padding: 0;
  width: ${(p: ColProp) => p.width}%;
`;

export const Title = styled.h1`
  margin: 10px;
  padding: 0;
  font-family: "palanquin";
  font-weight: 500;
  font-size: 2rem;
`;

export const IframeStyled = styled.iframe`
  width: 100%;
  height: 59vh;
  /* width */
  &::-webkit-scrollbar {
    width: 3px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: ${theme.colors.lightGray5};
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.lightGray};
    border-radius: 3px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.lightGray6};
  }
`;

export const ButtonComponentStyled = styled(Link)`
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  align-items: center;
  padding: 15px 45px;
  border-radius: 100px;
  font-size: 0.8rem;
  line-height: 1.6;
  &:hover {
    color: ${theme.colors.white};
    opacity: 0.7;
  }
  svg {
    margin-bottom: 2px;
    margin-right: 5px;
  }
`;
